import React from "react";
import { DropDownOption } from "../inputform/DropDown";
import { Alignment } from "../../types/system/Layout";

export enum GridColumnType {
    Text,
    Number,
    Date,
    Checkbox,
    Dropdown,
    Icon,
    Button,
    Html,
}

export type GridValueType = "" | "[RowNo]";

interface GridColumnProps<T> {
    header?: string;
    field?: string;
    blank?: boolean;
    value?: GridValueType;
    selectable?: boolean;
    editable?: boolean;
    editableField?: string;
    filterable?: boolean;
    visible?: boolean;
    visibleField?: string;
    icon?: string;
    cellTooltip?: string;
    cellTooltipMethod?: (item: T) => string;
    cellTooltipHtml?: boolean;
    headTooltip?: string;
    cellTooltipField?: string;
    width?: string;
    includeDate?: boolean;
    includeTime?: boolean;
    type?: GridColumnType;
    filterValue?: any;
    alignment?: Alignment;
    minNumber?: number;
    maxNumber?: number;
    allowNull?: boolean;
    naForNull?: boolean;
    decimalPlaces?: number;
    decimalIncrement?: number;
    options?: DropDownOption[];

    onClick?: (record: T, column: GridColumn<T>) => void;
}

class GridColumn<T> extends React.Component<GridColumnProps<T>> {
    header?: string;
    field?: string;
    blank?: boolean;
    value?: GridValueType;
    selectable: boolean;
    editable: boolean;
    editableField: string;
    filterable: boolean;
    visible: boolean;
    visibleField: string;
    icon: string;
    cellTooltip?: string;
    cellTooltipMethod?: (item: T) => string;
    cellTooltipHtml?: boolean;
    headTooltip?: string;
    cellTooltipField?: string;
    width: string;
    includeDate: boolean;
    includeTime: boolean;
    type?: GridColumnType;
    filterValue?: any;
    alignment?: Alignment;
    minNumber?: number;
    maxNumber?: number;
    allowNull?: boolean;
    naForNull?: boolean;
    decimalPlaces?: number;
    decimalIncrement?: number;
    options?: DropDownOption[];

    onClick?: (record: T, column: GridColumn<T>) => void;

    render(): React.ReactNode {
        return null;
    }
}

export default GridColumn;
